import React, { useEffect, useState, useContext, useCallback } from "react";
import { AuthContext } from "../../contexts/auth";
import { collection, getDocs, deleteDoc, doc } from "@firebase/firestore";
import { db } from '../../services/firebaseConnection';
import Header from "../../components/Header";
import Title from "../../components/Title";
import { FiStar, FiEdit, FiTrash , FiBookmark} from "react-icons/fi";

import 'bootstrap/dist/css/bootstrap.min.css'; 

import '../Dashboard/dashboard.css';
import { useNavigate } from 'react-router-dom';

export default function Perfil() {
    const { user } = useContext(AuthContext);
    const [posts, setPosts] = useState([]);
    const [users, setUsers] = useState([]);
    const [totalPosts, setTotalPosts] = useState(0);
    const [averageRating, setAverageRating] = useState(0);
    const navigate = useNavigate();

    const loadUserPosts = useCallback(async () => {
        const postsCollection = collection(db, "posts");
        const postsSnapshot = await getDocs(postsCollection);
        const userPosts = postsSnapshot.docs
            .map(doc => ({ 
                id: doc.id, 
                ...doc.data(),
                images: doc.data().images || [],
                ratings: doc.data().ratings || [],
                comments: doc.data().comments || [],
                showComments: false,
                created: doc.created ? doc.created.toDate() : null
            }))
            .filter(post => post.userId === user.user_id);
        setPosts(userPosts);

        userPosts.sort((a, b) => {
            if (!a.created) return 1;
            if (!b.created) return -1;
            return b.created - a.created;
        });

        setTotalPosts(userPosts.length);
        const totalRatings = userPosts.reduce((sum, post) => sum + post.ratings.reduce((sum, { rating }) => sum + rating, 0), 0);
        const totalRatingCount = userPosts.reduce((sum, post) => sum + post.ratings.length, 0);
        setAverageRating(totalRatingCount > 0 ? (totalRatings / totalRatingCount).toFixed(1) : 0);
    }, [user]);

    const loadUsers = useCallback(async () => {
        const usersCollection = collection(db, "users");
        const usersSnapshot = await getDocs(usersCollection);
        const usersList = usersSnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
        }));
        setUsers(usersList);
    }, []);

    useEffect(() => {
        loadUserPosts();
        loadUsers();
    }, [loadUserPosts, loadUsers]);

    const calculateAverageRating = (ratings) => {
        if (ratings.length === 0) return 0;
        const total = ratings.reduce((sum, { rating }) => sum + rating, 0);
        return (total / ratings.length).toFixed(1);
    };

    const getUserNameById = (userId) => {
        const userObj = users.find(user => user.id === userId);
        return userObj ? userObj.username : "Usuário Desconhecido";
    };

    const getStarColor = (averageRating, star) => {
        return star <= averageRating ? 'gold' : 'gray';
    };

    const handleDeletePost = async (postId) => {
        try {
            await deleteDoc(doc(db, "posts", postId));
            setPosts(posts.filter(post => post.id !== postId));
        } catch (error) {
            console.error("Erro ao deletar post:", error);
        }
    };

    const handleEditPost = (post) => {
        navigate('/editar', { state: { post } });
    };

    const toggleComments = (postId) => {
        const updatedPosts = posts.map(post => {
            if (post.id === postId) {
                return { ...post, showComments: !post.showComments };
            }
            return post;
        });
        setPosts(updatedPosts);
    };

    


    return (
        <div>
            <Header />
            <div id="body">
                <div id="content">
                    <Title name="Meus Posts">
                        <FiBookmark size={25} />
                    </Title>
                </div>
                <br/>
                <div id="stats">
                    <p>Total de posts: {totalPosts}</p>
                    <p>Média geral de avaliação: {averageRating}</p>
                </div>

                <div id="posts-container">
                    {posts.map((post) => (
                        <div key={post.id} id="post">
                            <h3>{post.titulo}</h3>
                            <p>{post.descricao}</p>
                            <p>{post.endereco}</p>
                            {post.images.length > 0 ? (
                                post.images.length > 1 ? (
                                    <div id={`carousel-${post.id}`} className="carousel slide" data-bs-ride="carousel">
                                        <div className="carousel-inner">
                                            {post.images.map((url, idx) => (
                                                <div key={idx} className={`carousel-item ${idx === 0 ? 'active' : ''}`}>
                                                    <img src={url} className="d-block w-100" alt={`Imagem ${idx + 1}`} />
                                                </div>
                                            ))}
                                        </div>
                                        <button className="carousel-control-prev" type="button" data-bs-target={`#carousel-${post.id}`} data-bs-slide="prev">
                                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                            <span className="visually-hidden">Anterior</span>
                                        </button>
                                        <button className="carousel-control-next" type="button" data-bs-target={`#carousel-${post.id}`} data-bs-slide="next">
                                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                            <span className="visually-hidden">Próximo</span>
                                        </button>
                                    </div>
                                ) : (
                                    <img src={post.images[0]} alt={`Imagem`} className="d-block w-100" />
                                )
                            ) : (
                                <p>Não há imagem.</p>
                            )}
                            <div className="ratings">
                                <p>Média de Estrelas: {calculateAverageRating(post.ratings)}</p>
                                <div className="stars">
                                    {[1, 2, 3, 4, 5].map((star) => (
                                        <FiStar
                                            key={star}
                                            color={getStarColor(Math.ceil(calculateAverageRating(post.ratings)), star)}
                                            className="star"
                                        />
                                    ))}
                                </div>
                            </div>
                            <div className="actions">
                                <button 
                                    onClick={() => handleEditPost(post)} 
                                    className="action-button btn btn-success btn-lg"
                                >
                                    <FiEdit size={20} />
                                    Editar
                                </button>
                                <button 
                                    onClick={() => handleDeletePost(post.id)} 
                                    className="action-button btn btn-danger btn-lg"
                                >
                                    <FiTrash size={20} />
                                    Deletar
                                </button>
                            </div>
                            <div className="comments">
                                {post.comments.length > 0 && (
                                    <button
                                        className="toggle-comments"
                                        onClick={() => toggleComments(post.id)}
                                    >
                                        {post.showComments ? 'Esconder Comentários' : 'Mostrar Comentários'}
                                    </button>
                                )}
                                {post.showComments && post.comments.length > 0 && (
                                <div className="comment-list">
                                {post.comments.map((comment, index) => (
                                    <p key={index}>
                                        <strong>{getUserNameById(comment.userId)}:</strong> {comment.comment}
                                    </p>
                                ))}
                            </div>
                                    )}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
